import { gray95opacity10 } from '../../../colors/gray';
export var MuiDialogTitle = {
    customOverrides: {
        header: {
            backgroundColor: gray95opacity10,
        },
        filled: {
            backgroundColor: gray95opacity10,
        },
    },
};
